import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import { Bot } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";
import { useCurrentPageContext } from "~/contexts/page-context";
import useUser from "~/contexts/user";
import { cn } from "~/lib/utils";

// Debug-mode only: shows the page context sent to the agent, red when the page
// declares none.
export function PlatformContextTooltip() {
  const user = useUser();
  const enabled = useFliptBoolean("agent-debug-mode", false, user?.email);
  const context = useCurrentPageContext();

  if (!enabled) return null;

  return (
    <Tooltip>
      <TooltipTrigger
        aria-label="Page context"
        className={cn(
          "inline-flex size-7 cursor-help items-center justify-center",
          context ? "text-muted-foreground hover:text-foreground" : "text-destructive"
        )}
      >
        <Bot className="size-4" aria-hidden />
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-[18rem]">
        {context ? (
          <>
            <b>Context:</b> {context}
          </>
        ) : (
          <>
            <b>No context:</b> this page sends the agent no hint about where the user is.
          </>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
